import * as React from "react";
import "./footer.less";

const Footer = () => {
	return (
	  <div className={"footer"}>
			<p>&copy; 2024 Gary Hill.  Disclaimer: This software is provided "as is" without warranty of any kind.</p>
	  </div>
	);
};

export default Footer;